/* eslint-disable indent */
import React from "react";
import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewMiscellaneousDetails({
  miscellaneousDetails,
  apiResponse,
  id,
}) {
  return (
    <>
      {" "}
      <ViewDetailsHeading
        text={"Miscellaneous Details"}
        itemkey={4}
        apiResponse={apiResponse}
        id={id}
      />
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">
            {" "}
            Miscellaneous Detailss
          </div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Experience in courier industry"}
                  hub={miscellaneousDetails?.experience}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Office ownership"}
                  hub={miscellaneousDetails?.ownerShip}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"If CP owns vehicle for First mile delivery?"}
                  hub={
                    miscellaneousDetails?.checkVehicleAvailability
                      ? "Yes"
                      : "No"
                  }
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Name of the previous courier company"}
                  hub={miscellaneousDetails?.perviousCompany}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Office area in sq. ft."}
                  hub={miscellaneousDetails?.officeInSQRT}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Number Of Vehicles"}
                  hub={miscellaneousDetails?.numberOfVehicles}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Monthly turnover (approximate)"}
                  hub={miscellaneousDetails?.monthlyTurnover}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"No. of staff"}
                  hub={miscellaneousDetails?.staff}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
